import { ReactNodeViewRenderer, Node, mergeAttributes } from '@tiptap/react'
import { Component } from './component'

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		signupForm: {
			setSignupForm: () => ReturnType
			setSimpleFormRedirect: (redirect: boolean) => ReturnType
			setSimpleFormRedirectUrl: (redirectUrl: string) => ReturnType
			setSimpleFormState: (
				state: 'Success' | 'Error' | 'Idle' | 'Loading',
			) => ReturnType
		}
	}
}

export const SimpleForm = Node.create({
	name: 'simple-form',

	isolating: true,

	content: 'text*',

	defining: true,

	group: 'block',

	allowGapCursor: false,

	draggable: true,

	selectable: true,

	addAttributes() {
		return {
			placeholder: {
				default: 'Email',
			},
			redirect: {
				default: false,
			},
			redirectUrl: {
				default: '',
			},
			successText: {
				default: 'Verify your email',
			},
			state: {
				default: 'Idle',
			},
		}
	},

	parseHTML() {
		return [
			{
				tag: this.name,
			},
		]
	},

	renderHTML({ HTMLAttributes }) {
		return [this.name, mergeAttributes(HTMLAttributes), 0]
	},

	addCommands() {
		return {
			setSignupForm:
				() =>
				({ commands }) =>
					commands.insertContent({
						type: this.name,
					}),
			setSimpleFormRedirect:
				redirect =>
				({ commands }) =>
					commands.updateAttributes('simple-form', { redirect }),
			setSimpleFormRedirectUrl:
				redirectUrl =>
				({ commands }) =>
					commands.updateAttributes('simple-form', { redirectUrl }),
			setSimpleFormState:
				state =>
				({ commands }) =>
					commands.updateAttributes('simple-form', { state }),
		}
	},

	addNodeView() {
		return ReactNodeViewRenderer(Component)
	},
})

export default SimpleForm
